// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TabProps } from "@insite/mobius/Tab";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@sc/XDL/types";
import { color, styledScrollbar } from "@sc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            weight: "bold",
            css: css`
                line-height: 19px;
            `,
        },
        css: css`
            position: relative;
            border-bottom: 0;
            background-color: ${color("common.ui2")};
            display: inline-flex;
            transition: all 0.2s;
            justify-content: center;
            &:last-child {
                border-radius: 0 21px 21px 0;
            }
            &:first-child {
                border-radius: 21px 0 0 21px;
            }

            padding: 11px 20px 12px;
            cursor: pointer;
            color: ${color("primary.main")};

            &:hover {
                opacity: 0.44;
                border-bottom: 0;
            }

            &:focus {
                outline: none;
            }

            ${({ selected }: TabProps) =>
                selected &&
                css`
                    z-index: 1;
                    color: ${color("common.white")};
                    border-radius: 21px !important;
                    background-color: ${color("common.ui9")};
                `}
        `,
    },
    groupDefaultProps: {
        mergeCss: true,
        cssOverrides: {
            tabGroup: css`
                padding: 0 2px 0 0;
                position: relative;
                &,
                & > div {
                    position: relative;
                    white-space: nowrap;
                    ${styledScrollbar()}
                }
                & > div {
                    background: ${color("common.ui2")};
                    border-radius: 21px;
                }
            `,
            tabContent: css`
                position: relative;
                margin-top: 0;
                padding: 16px 0 0 0;
                border-top: 0;
                border-bottom: 0;
            `,
            wrapper: css`
                width: 100%;
            `,
        },
    },
} as xBaseTheme["tab"];
